import { useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import paywallService from '../services/paywallService';

const useContentAccess = () => {
    const [hasAccess, setHasAccess] = useState(false);
    const [hasPurchased, setHasPurchased] = useState(false);
    const [accessChecked, setAccessChecked] = useState(false);
    const [showPaywall, setShowPaywall] = useState(false);
    const [loading, setLoading] = useState(false);

    const { isAuthenticated, isAuthLoading } = useAuth();

    const checkAccess = useCallback(async (contentId, contentType, isCreator = false) => {
        if (isCreator) {
            setHasAccess(true);
            setHasPurchased(true);
            setAccessChecked(true);
            setShowPaywall(false);
            return true;
        }

        if (isAuthLoading) {
            return false;
        }

        setAccessChecked(false);
        setLoading(true);

        try {
            if (!isAuthenticated) {
                setHasAccess(false);
                setHasPurchased(false);
                setAccessChecked(true);
                setShowPaywall(true);
                return false;
            }

            const result = await paywallService.checkAccess(contentType, contentId);

            if (result.has_purchased || result.has_access) {
                setHasAccess(true);
                setHasPurchased(true);
                setShowPaywall(false);
                return true;
            }

            setHasAccess(false);
            setHasPurchased(false);
            setShowPaywall(true);
            return false;

        } catch (error) {
            console.error('Access check failed:', error);
            setHasAccess(false);
            setHasPurchased(false);
            setShowPaywall(true);
            return false;
        } finally {
            setAccessChecked(true);
            setLoading(false);
        }
    }, [isAuthenticated, isAuthLoading]);

    return {
        hasAccess,
        hasPurchased,
        accessChecked,
        showPaywall,
        loading: loading || !accessChecked,
        checkAccess,
        setShowPaywall
    };
};

export default useContentAccess;